import { AppRolePermissions } from '../../permissions'

const PRODUCT_PORTFOLIO: AppRolePermissions = {
  active_assortment_view: true,
  assortment_backups_create: true,
  assortment_backups_restore: true,
  assortment_banners_edit: true,
  assortment_banners_publish: true,
  assortment_banners_view: true,
  assortment_launches_create: true,
  assortment_launches_edit: true,
  assortment_launches_publish: true,
  assortment_launches_view: true,
  assortment_materials_clean_up: true,
  assortment_materials_replace: true,
  assortment_materials_sequences_edit: true,
  assortment_materials_sync: true,
  audit_trails_view: false,
  customers_banners_view: false,
  customers_stores_view: true,
  invites_delete: false,
  invites_send: false,
  invites_view: false,
  map_viewAllAreas: false,
  materials_bcp_priced_view: true,
  materials_materials_list_view: false,
  materials_price_list_view: false,
  operations_execute: false,
  orders_all_view: true,
  orders_charts_view: true,
  orders_editQuantities: false,
  orders_flagged_view: true,
  orders_leg_release_timeout_edit: false,
  orders_payment_review_release: false,
  orders_payment_review_view: false,
  orders_uncouple: false,
  orders_release: false,
  orders_returns_view: false,
  reports_view: true,
  reports_view_ecc: true,
  reports_view_material: true,
  reports_view_misc: true,
  reports_view_operations: false,
  reports_view_order_service: true,
  reports_view_salesforce: true,
  roles_view: false,
  sox_compliance_scheduled_reports_create: false,
  sox_compliance_scheduled_reports_delete: false,
  sox_compliance_scheduled_reports_edit: false,
  sox_compliance_view: false,
  upload_allUploads_view: false,
  upload_autoDistro: false,
  upload_autoInject: false,
  upload_autoInjectDeliveryDates: false,
  upload_autoInjectRMA: false,
  upload_ediPOConfControl: false,
  upload_erpSkuSubstitution: true,
  upload_limitQuantity: false,
  upload_limitQuantityExemptions: false,
  upload_materialSpecificationConversion: true,
  upload_merchandise: true,
  upload_myUpload_view: true,
  upload_nodAddPosition: false,
  upload_onHandInventoryDuns: false,
  upload_onHandInventoryPartial: false,
  upload_onHandInventoryUOM: false,
  upload_routeStopSequence: false,
  upload_skuUpcOverride: true,
  upload_suspendOrderSubmission: false,
  upload_taxRate: false,
  users_manageAdmins: false,
  users_managePermissionsOverrides: false,
  users_manageAccess: false,
  users_manageTerritoriesOverrides: false,
  users_view: false,
}

export default PRODUCT_PORTFOLIO
